import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from "../Tabs/Tabs";
import RoleBuilderWorkspace from "./RoleBuilderWorkspace";
import RoleBuilderErrors from "./RoleBuilderErrors";

export default class RoleBuilder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: this.props.errors || {},
      loading: false,
      id: this.props.id || null,
      role_name: this.props.name || null,
      role_save_path: this.props.role_save_path || null,
      revert: this.props.revert || null,
      active_tab: "general",
      role_resources: this.props.role_resources || [],
      read_only: this.props.read_only || false,
      role_system_notification_types:
        this.props.role_system_notification_types || [],
      modifying_self: this.props.modifying_self || null,
      owner: this.props.owner || null,
      role_revision_history_path: this.props.role_revision_history_path,
      date_format: this.props.date_format,
      time_format: this.props.time_format,
      roleDashboards: this.props.role_dashboards || [],
      system_notification_types: this.props.system_notification_types || [],
    };

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.prepParams = this.prepParams.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onChangeResources = this.onChangeResources.bind(this);
    this.onChangeSystemNotificationTypes =
      this.onChangeSystemNotificationTypes.bind(this);
    this.onAddDashboard = this.onAddDashboard.bind(this);
    this.onRemoveDashBoard = this.onRemoveDashBoard.bind(this);
    this.onChangeDashboardPosition = this.onChangeDashboardPosition.bind(this);
  }

  render() {
    var self = this;
    if (this.state.read_only == false || this.props.allow_edit_dashboard) {
      if (
        this.props.system_data &&
        !this.props.superAdminUser &&
        !this.props.allow_edit_dashboard
      ) {
        var buttons = [
          {
            name: I18n.t("ok"),
            html_attributes: ['data-dismiss="modal"'],
          },
        ];
      } else {
        var buttons = [
          {
            name: I18n.t("cancel"),
            html_attributes: ['data-dismiss="modal"'],
          },

          {
            name: I18n.t("submit"),
            button_classes: ["primary"],
            onClick: function (e) {
              self.onSave();
            },
          },
        ];
      }
    }

    return (
      <div className="RoleBuilder">
        <ModalButtons loading={this.state.loading} buttons={buttons} />
        {
          // this.props.system_data &&
          // !this.state.read_only && !this.props.superAdminUser
          //   ?
          // <div className="alert alert-warning">{I18n.t('system_data_roles_cannot_be_modified', {name: this.props.name})}</div>
          //   :
          <div>
            <div className="panel panel-form">
              <Tabs
                tabs={this.tabs()}
                displayErrorMessage={
                  RoleBuilderErrors.general(this.state.errors).length ||
                  RoleBuilderErrors.permissions(this.state.errors).length ||
                  RoleBuilderErrors.system_notification_types(this.state.errors)
                    .length
                    ? true
                    : false
                }
              />
              <RoleBuilderWorkspace
                {...this.props}
                {...this.state}
                system_data={this.props.system_data}
                allow_edit_dashboard={this.props.allow_edit_dashboard}
                onChangeName={this.onChangeName}
                onChangeResources={this.onChangeResources}
                onChangeSystemNotificationTypes={
                  this.onChangeSystemNotificationTypes
                }
                onAddDashboard={this.onAddDashboard}
                onRemoveDashBoard={this.onRemoveDashBoard}
                onChangeDashboardPosition={this.onChangeDashboardPosition}
              />
            </div>
            <LoadingSpinner show={this.state.loading} />
          </div>
        }
      </div>
    );
  }

  tabs() {
    return this.props.read_only && this.state.revert != true
      ? [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: RoleBuilderErrors.general(this.state.errors).length,
          },
          {
            tabName: I18n.t("permissions"),
            targetName: "permissions",
            classes: this.state.active_tab === "permissions" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: RoleBuilderErrors.permissions(this.state.errors)
              .length,
          },
          {
            tabName: I18n.t("notifications"),
            targetName: "system_notification_types",
            classes:
              this.state.active_tab === "system_notification_types"
                ? "active"
                : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: RoleBuilderErrors.system_notification_types(
              this.state.errors
            ).length,
          },
          {
            tabName: I18n.t("dashboards"),
            targetName: "dashboards",
            classes: this.state.active_tab === "dashboards" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("history"),
            targetName: "history",
            classes: this.state.active_tab === "history" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      : [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: RoleBuilderErrors.general(this.state.errors).length,
          },
          {
            tabName: I18n.t("permissions"),
            targetName: "permissions",
            classes: this.state.active_tab === "permissions" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: RoleBuilderErrors.permissions(this.state.errors)
              .length,
          },
          {
            tabName: I18n.t("notifications"),
            targetName: "system_notification_types",
            classes:
              this.state.active_tab === "system_notification_types"
                ? "active"
                : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: RoleBuilderErrors.system_notification_types(
              this.state.errors
            ).length,
          },
          {
            tabName: I18n.t("dashboards"),
            targetName: "dashboards",
            classes: this.state.active_tab === "dashboards" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ];
  }

  onChangeActiveTab(name) {
    this.setState({
      active_tab: name,
    });
  }

  onChangeName(e) {
    this.setState({
      role_name: e.target.value,
    });
  }

  onChangeResources(resources) {
    this.setState({
      role_resources: resources,
    });
  }

  onChangeSystemNotificationTypes(role_system_notification_types) {
    this.setState({
      role_system_notification_types: role_system_notification_types,
    });
  }

  onAddDashboard(dashboard) {
    var newUserDashboard = {
      position: this.state.roleDashboards.length,
      dashboard: dashboard,
    };

    var roleDashboards = [...this.state.roleDashboards, newUserDashboard];
    this.setState({ roleDashboards: roleDashboards });
  }

  onRemoveDashBoard(dashboardId) {
    var roleDashboards = this.state.roleDashboards.filter(
      (ud) => ud.dashboard.id != dashboardId
    );

    this.setState({ roleDashboards: roleDashboards });
  }

  onChangeDashboardPosition(orderedDashboardIds) {
    var currentroleDashboards = [...this.state.roleDashboards];
    var roleDashboards = orderedDashboardIds.map((id) => {
      var dashboard = currentroleDashboards.find(
        (ud) => ud.dashboard.id === id
      );
      return dashboard;
    });

    this.setState({
      roleDashboards: roleDashboards,
    });
  }

  prepParams() {
    var role = {
      id: this.state.id,
      name: this.state.role_name,
      role_resources: this.state.role_resources,
      role_system_notification_types: this.state.role_system_notification_types,
      updated_at: this.props.updated_at,
      created_at: this.props.created_at,
      dashboard_ids: this.state.roleDashboards.map((ud) => ud.dashboard.id),
    };
    return role;
  }

  onSave() {
    var self = this;
    var role = self.prepParams();

    this.setState({ loading: true });
    $.ajax({
      type: this.props.new_record ? "POST" : "PATCH",
      url: this.props.role_create_path,
      data: {
        role: role,
      },
    })
      .done((data) => {
        window.parent.$(window.parent).trigger("roleSaved", data);
        this.setState({ loading: false });
        if (parent && parent.refresh_data) {
          parent.refresh_data(
            this.props.new_record
              ? I18n.t("role_successfully_created")
              : I18n.t("role_successfully_saved")
          );
        }

        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      })
      .catch((data) => {
        if (data && data.responseJSON) {
          this.setState({ errors: data.responseJSON, loading: false });
          $(".modal-body").scrollTop(0);
        }
      });
  }
}
